import React, { useState } from 'react'
import { Avatar, Button, CardHeader, Grid, Paper, TextField, Typography } from '@mui/material'
import { LockOutlined } from '@mui/icons-material'
import { AuthApi } from '../services/apirest'
import Logo from '../img/logoNetizar.png'
import { useNavigate } from 'react-router-dom'

export default function Login() {
  let navigate = useNavigate()

  const paperStyle = {
    padding: 20,
    height: '70vh',
    width: 250,
    margin: '20px auto',
    backgroundColor: '#f5f6f7',
  }
  const avatarStyle = { backgroundColor: '#1bbd7e' }
  const btnstyle = { margin: '8px 0' }

  const [mensaje, setMensaje] = useState('')
  const [username, setUserName] = useState('')
  const [password, setPassword] = useState('')

  const guardarlocal = response => {
    console.log(response)
    localStorage.setItem('token', response.token)
    localStorage.setItem('user', response.user.username)
    localStorage.setItem('token-expiration', Date.now() + 2 * 60 * 60 * 1000)
    localStorage.setItem('adminT1', response.user.adminT1)
    localStorage.setItem('sucursal', response.user.sucursal)
    localStorage.setItem('sucursalnombre', response.user.nombre)
    localStorage.setItem('patente', response.user.patente)
  }
  const handleEntrar = async e => {
    e.preventDefault()
    await fetch(AuthApi + 'login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        username: username,
        password: password,
      }),
    })
      .then(res => res.json())
      .then(data =>
        data.token
          ? (guardarlocal(data), setMensaje('Ingreso correcto'), navigate('navbar'))
          : setMensaje('Error de ingreso')
      )
  }

  return (
    <Grid>
      <Paper elevation={10} style={paperStyle}>
        <Grid align='left'>
          <CardHeader
            avatar={
              <Avatar style={avatarStyle}>
                <LockOutlined />
              </Avatar>
            }
            title={<Typography variant='h5'>T1 transporte</Typography>}
          />
        </Grid>
        <TextField
          variant='standard'
          label='Usuario'
          placeholder='Entre usuario'
          value={username}
          onChange={e => setUserName(e.target.value)}
          fullWidth
          autoComplete='off'
          required
        />
        <br />
        <br />
        <TextField
          variant='standard'
          label='Password'
          placeholder='Entre password'
          type='password'
          value={password}
          onChange={e => setPassword(e.target.value)}
          fullWidth
          autoComplete='new-password'
          required
        />
        <br />
        <br />
        <Button
          color='primary'
          variant='outlined'
          style={btnstyle}
          onClick={handleEntrar}
          fullWidth>
          Entrar
        </Button>
        <br />
        <br />
        <br />
        <br />
        {mensaje}
        <br />
        <br />
        <br />
        <br />
        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
          <img src={`${Logo}`} style={{ paddingLeft: '50px' }} alt=''></img>
          <span style={{ paddingLeft: '10px', fontSize: '14pt', fontWeight: 'medium' }}>
            Netizar
          </span>
        </div>
      </Paper>
    </Grid>
  )
}
